export default "__VITE_ASSET__gXQY0N6P__"